<template>
    <aside class="main-sidebar col-md-3 ">
        <section class="sidebar">
            <div class="photoBox">
                <div
                        v-if="saveInProgress"
                        style="height: 200px; padding-top:60px"
                >
                    <vue-simple-spinner
                            :size="32"
                            message="Chargement en cours..."
                            :spacing="25"
                            text-fg-color="#FFF"
                            :font-size="16"

                    ></vue-simple-spinner>
                </div>
                <div v-if="!saveInProgress">
                    <a class="changePhotoLink" v-if="!getClub.logo || getClub.logo==''" @click="show_upload_logo=!show_upload_logo">
                        <i class="fa fa-picture-o"></i> Mettre à jour <br/>le logo du club
                    </a>
                    <a class="changePhotoLink" v-if="getClub.logo && getClub.logo!=''" @click="deleteLogo()">
                        <i class="fa fa-picture-o"></i> Enlever <br/>ce logo
                    </a>
                    <img v-if="getClub.logo && getClub.logo!=''" :src="getClub.logo" class="img-responsive" alt=""/>
                    <img v-if="!getClub.logo || getClub.logo==''" @click="show_upload_logo=!show_upload_logo" src="../../assets/img/logos/importLogo.jpg" class="img-responsive" alt=""/>

                    <my-upload field="img"
                               @crop-success="cropSuccess"
                               @crop-upload-success="cropUploadSuccess"
                               @crop-upload-fail="cropUploadFail"
                               v-model="show_upload_logo"
                               langType="fr"
                               :height="200"
                               :width="300"
                               :noCircle="true"
                               img-format="jpg">
                    </my-upload>
                </div>
                <div class="nameBox">
                    <p>{{ getClub.club }}</p>
                    <p class="sousName">Club ABFT</p>
                </div>
            </div>

            <div class="col-md-12 tableSection">
                <h3><i class="fa fa-user"></i> Profil</h3>

                <div class="col-md-6 cell brRight">
                    <span class="mainTitle">{{ getClub.numero_club }}</span>
                    <span class="subTitle">Numéro du club</span>
                </div>
                <div class="col-md-6 cell brRight">
                    <span class="mainTitle">{{ getClub.membresThisYear }}</span>
                    <span class="subTitle">{{ getClub.membresThisYear>1 ? "membres" : "membre"}} en {{ currentYear() }}</span>
                </div>
            </div>

            <div class="col-md-12 tableSection">
                <div class="cell">
                    <span class="mainTitle clubName">Dernière affiliation</span>
                    <span class="subTitle">Affiliation {{  getClub.lastLicence.annee }}</span>
                </div>
            </div>
<!--            <div class="col-md-12 tableSection">-->
<!--                <div class="cell">-->
<!--                    <span class="mainTitle clubName">Message de l'A.B.F.T.</span>-->
<!--                    <div class="messageSidebar" style="padding: 10px">-->
<!--                      Lorem ipsum dolor sit amet, consectetur adipisicing elit. Doloremque dolores eveniet ipsa itaque laborum maxime non quae quasi ratione voluptatum? A ad deserunt dolore itaque numquam quos similique <a href="">test</a> sit ullam!-->
<!--                    </div>-->
<!--                </div>-->
<!--            </div>-->

        </section>
    </aside>
</template>

<style scoped>
    .main-sidebar {
        margin-top: 0;
        padding: 0;
        background-color: #292e33;
    }

    .sidebar {
        padding-top: 0;
    }
    .messageSidebar {
      font-size: 12px;
      padding-left: 10px;
      padding-right: 10px;
      text-align: center;
      line-height: 16px;
    }
</style>

<script type="text/babel">
    import Auth from '@/auth'
    import {mapGetters, mapActions} from 'vuex'
    import moment from 'moment/moment'
    import cropUpload from '../ImgCropUpload'


    export default {
        data() {
            return {
                show_upload_logo: false,
                saveInProgress: false
            }
        },
        components: {
            'my-upload': cropUpload
        },
        watch: {
            'getClub.logo': function () {
                this.saveInProgress = true
                this.$http.post(process.env.API_URL + "saveLogoClub", {
                    id_club: this.getClub.id,
                    logo: this.getClub.logo
                })
                    .then((response) => {
                        this.saveInProgress = false
                        if (this.getClub.logo != null)
                            this.$noty.success("Le logo a été sauvegardé")
                    }, (response) => {
                        this.saveInProgress = false
                        this.$noty.error("Erreur lors de la sauvegarde du logo")
                    })
            }
        },
        methods: {
            currentYear: function () {
                return moment().year();
            },
            ucwords: function (str) {
                if (!str)
                    return ""
                return str.toLowerCase().replace(/\b[a-z]/g, function (letter) {
                    return letter.toUpperCase();
                });
            },
            deleteLogo() {
                this.getClub.logo = null;
            },
            cropSuccess(imgDataUrl, field) {
                this.show_upload_logo = false
                this.getClub.logo = imgDataUrl;
            },
            cropUploadSuccess(jsonData, field) {
            },
            cropUploadFail(status, field) {
            },
            number_format: function (number, decimals, dec_point, thousands_point) {

                if (number == null || !isFinite(number)) {
                    throw new TypeError("number is not valid");
                }

                if (!decimals) {
                    var len = number.toString().split('.').length;
                    decimals = len > 1 ? len : 0;
                }

                if (!dec_point) {
                    dec_point = '.';
                }

                if (!thousands_point) {
                    thousands_point = ',';
                }

                number = parseFloat(number).toFixed(decimals);

                number = number.replace(".", dec_point);

                var splitNum = number.split(dec_point);
                splitNum[0] = splitNum[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands_point);
                number = splitNum.join(dec_point);

                return number;
            }
        },
        computed: {
            ...mapGetters({
                getMember: 'getMember',
                getClub: 'getClub',
            }),

        },
    };
</script>



// WEBPACK FOOTER //
// src/components/Club/Sidebar.vue